// extracted by mini-css-extract-plugin
export default {"overWriteContent":"src-pages-SalesChannelContentEditor-SalesChannelEditorProductSearch-FeaturedProduct-css__overWriteContent--LFO7l"};